import React from "react";
// styled components

// models
interface IProps {
  TituloSpan: string;
  TitulosinSpan: string;
}

export const TextoInicialJurados: React.FC<IProps> = (props: IProps) => {
  return (
    <div className="row mt-4">
      <div className="no-margin col-12 font-family-Montserrat-Regular font-size-18px">
        <span className="font-family-Montserrat-SemiBold">{props.TituloSpan}</span> {props.TitulosinSpan}
      </div>
    </div>
  );
};
